(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-styles"]) return;
  try {
    
  (function () {
    var root = document.documentElement;
    root.classList.add('sq-js');

    function mark(img) {
      img.classList.add('sq-loaded');
    }

    function watch(scope) {
      (scope || document).querySelectorAll('.sc__media img').forEach(function (img) {
        if (img.classList.contains('sq-loaded')) return;
        if (img.complete && img.naturalWidth > 0) {
          mark(img);
        } else {
          img.addEventListener('load', function () { mark(img); }, { once: true });
          img.addEventListener('error', function () { mark(img); }, { once: true });
        }
      });
    }

    watch();
    document.addEventListener('DOMContentLoaded', function () { watch(); });
    window.addEventListener('load', function () { watch(); });
    // Safety net: never leave a photo hidden
    setTimeout(function () {
      document.querySelectorAll('.sc__media img').forEach(mark);
    }, 4000);

    var bar = null;
    function start() {
      if (bar) return;
      bar = document.createElement('div');
      bar.className = 'sq-progress';
      document.body.appendChild(bar);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bar.classList.add('sq-progress--run');
        });
      });
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      var u;
      try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname && u.search === location.search) return;
      start();
    });

    window.addEventListener('pageshow', function () {
      if (bar) {
        bar.remove();
        bar = null;
      }
    });

    /* ---------- Cart "Apply" and "Remove" code buttons ----------
       Lives here (not in the cart snippet) because this file loads on every page,
       even when the cart was empty on page load. */
    function cartUpdateUrl() {
      return (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update.js';
    }

    document.addEventListener('click', function (e) {
      var rm = e.target.closest && e.target.closest('[data-remove-code]');
      if (!rm || rm.disabled) return;
      e.preventDefault();
      rm.disabled = true;
      rm.textContent = 'Removing…';
      fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' })
      })
        .then(function () { window.location.reload(); })
        .catch(function () {
          rm.disabled = false;
          rm.textContent = 'Remove';
        });
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-apply-code]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var code = btn.getAttribute('data-apply-code');
      var label = 'Apply';
      btn.disabled = true;
      btn.textContent = 'Applying…';

      function reset(msg) {
        btn.textContent = msg || label;
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = label;
        }, 2500);
      }

      function applied() {
        return !!document.querySelector('.cart-discount__pill[data-discount-code="' + code + '"]');
      }

      function direct() {
        fetch(cartUpdateUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code })
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ok = d && d.discount_codes && d.discount_codes.some(function (x) {
              return x.code === code && x.applicable;
            });
            if (ok) {
              btn.textContent = 'Applied ✓';
              window.location.reload();
            } else {
              reset('Not available');
            }
          })
          .catch(function () { reset('Try again'); });
      }

      var scope = btn.closest('.cart-drawer__summary, .cart-summary') || document;
      var comp = scope.querySelector('cart-discount-component') || document.querySelector('cart-discount-component');
      var input = comp && comp.querySelector('input[name="discount"]');
      var form = input && input.closest('form');

      if (form) {
        input.value = code;
        try {
          if (form.requestSubmit) {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          }
        } catch (err) {}
        setTimeout(function () {
          if (!applied()) direct();
        }, 1500);
      } else {
        direct();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(v) {
      try {
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        return Number(v).toLocaleString(undefined, { style: 'currency', currency: cur });
      } catch (e) {
        return '$' + v;
      }
    }

    function setup(root) {
      (root || document).querySelectorAll('[data-cban-search]').forEach(function (form) {
        if (form.dataset.ready) return;
        form.dataset.ready = '1';

        var input = form.querySelector('input[type="search"]');
        var box = form.querySelector('[data-cban-suggest]');
        var base = form.dataset.suggestUrl;
        var timer = null;
        var controller = null;

        function hide() {
          box.hidden = true;
          box.innerHTML = '';
        }

        function render(q, products) {
          box.innerHTML = '';
          if (!products.length) {
            var none = document.createElement('p');
            none.className = 'cban__suggest-empty';
            none.textContent = 'No matches yet. Try another word.';
            box.appendChild(none);
            box.hidden = false;
            return;
          }
          products.forEach(function (prod) {
            var a = document.createElement('a');
            a.className = 'cban__suggest-item';
            a.href = prod.url;
            if (prod.featured_image && prod.featured_image.url) {
              var img = document.createElement('img');
              var u = prod.featured_image.url;
              img.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96';
              img.alt = '';
              img.loading = 'lazy';
              a.appendChild(img);
            }
            var text = document.createElement('span');
            text.className = 'cban__suggest-text';
            var title = document.createElement('strong');
            title.textContent = prod.title;
            var price = document.createElement('span');
            price.textContent = prod.available === false ? 'Sold out' : money(prod.price);
            text.appendChild(title);
            text.appendChild(price);
            a.appendChild(text);
            box.appendChild(a);
          });
          var all = document.createElement('a');
          all.className = 'cban__suggest-all';
          all.href = form.action + '?type=product&q=' + encodeURIComponent(q);
          all.textContent = 'See all results for “' + q + '”';
          box.appendChild(all);
          box.hidden = false;
        }

        input.addEventListener('input', function () {
          var q = input.value.trim();
          clearTimeout(timer);
          if (q.length < 2) {
            hide();
            return;
          }
          timer = setTimeout(function () {
            if (controller) controller.abort();
            controller = new AbortController();
            var url =
              base +
              '.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6' +
              '&resources[options][unavailable_products]=last' +
              '&resources[options][fields]=title,product_type,variants.title,tag';
            fetch(url, { signal: controller.signal })
              .then(function (r) { return r.json(); })
              .then(function (d) {
                var list = d && d.resources && d.resources.results && d.resources.results.products;
                render(q, list || []);
              })
              .catch(function () {});
          }, 200);
        });

        input.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') hide();
        });
        document.addEventListener('click', function (e) {
          if (!form.contains(e.target)) hide();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setup(); });
    } else {
      setup();
    }
    document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dark-mode-toggle"]) return;
  try {
    
  (function () {
    function sync(btn) {
      var dark = document.documentElement.getAttribute('data-theme') === 'dark';
      btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
      var icon = btn.querySelector('.dm-toggle__icon');
      if (icon) icon.textContent = dark ? '☀️' : '🌙';
    }
    function init() {
      document.querySelectorAll('[data-dm-toggle]').forEach(function (btn) {
        if (btn.dataset.dmReady) return;
        btn.dataset.dmReady = '1';
        sync(btn);
        btn.addEventListener('click', function () {
          var root = document.documentElement;
          var goingDark = root.getAttribute('data-theme') !== 'dark';
          if (goingDark) {
            root.setAttribute('data-theme', 'dark');
          } else {
            root.removeAttribute('data-theme');
          }
          try {
            localStorage.setItem('sq-theme', goingDark ? 'dark' : 'light');
          } catch (e) {}
          sync(btn);
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viral-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      var scope = root || document;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scope.querySelectorAll('.viral__frame').forEach(function (frame) {
        if (frame.dataset.viralReady) return;
        frame.dataset.viralReady = '1';
        var video = frame.querySelector('video');
        var sound = frame.querySelector('[data-viral-sound]');
        if (!video) return;

        if ('IntersectionObserver' in window && !reduce) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          }, { threshold: [0, 0.6, 1] }).observe(frame);
        }

        frame.addEventListener('click', function (event) {
          if (sound && sound.contains(event.target)) return;
          if (video.paused) { video.play().catch(function () {}); } else { video.pause(); }
        });

        if (sound) {
          sound.addEventListener('click', function () {
            video.muted = !video.muted;
            sound.textContent = video.muted ? '🔇' : '🔊';
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setup(); });
    } else {
      setup();
    }
    document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
